import { TWO_FA_INPUT_KEYS } from 'components/UI/molecules/TwoFASwitch/_constants/inputKeys';
import type { TwoFAFormInput } from 'components/UI/molecules/TwoFASwitch/_constants/inputKeys';

import type { TwoFADto } from '../types';

export const parseTwoFAForBE = (twoFA: TwoFAFormInput): TwoFADto => ({
  use_2fa: twoFA[TWO_FA_INPUT_KEYS.twoFA],
});
